<template>
  <a-modal v-model="visible" :title="title" :footer="null" class="preview-modal" :width="840">
    <AiScoreViewDetail :ai-score="record" />
  </a-modal>
</template>

<script>
import AiScoreViewDetail from '@/pages/project/case/components/AiScoreViewDetail';

export default {
  components: { AiScoreViewDetail },
  data() {
    return {
      title: null,
      visible: false,
      record: null
    };
  },
  methods: {
    onOpen(data, title = null) {
      this.title = title;
      this.visible = true;
      this.record = data;
    }
  }
};
</script>
<style>
.preview-modal .ant-modal-body {
  min-height: 50vh;
  max-height: 80vh;
  overflow: auto !important;
}
</style>
